// extracted by mini-css-extract-plugin
export default {"showMoreButtonWrapper":"news-module__showMoreButtonWrapper--N53PI","showMoreButton":"news-module__showMoreButton--RINgX"};